/**
 * Purpose:
 *   Tailwind style constants for the BlankState UI component layout and typography.
 */

export const blankStateStyles = {
  container: `
    flex flex-col items-center text-center gap-4
  `,
  containerCompact: `
    flex flex-col items-center text-center gap-3
  `,
  illustration: `
    w-full max-w-[180px]
  `,
  illustrationCompact: `
    w-full max-w-[6rem]
  `,
  message: `
    text-neutral-500 text-sm md:text-base
  `,
  messageCompact: `
    text-neutral-500 text-xs md:text-sm
  `,
  action: `
    flex justify-center
  `,
  actionCompact: `
    flex justify-center
  `,
};
